import { FC, useEffect, useState } from 'react';
import Modal from '@new/common/ui/Modal/Modal';
import { Progress } from '@new/common/ui/Progress/Progress';
import ManWithBulbSvg from '@assets/man-with-bulb.svg';

import { useExamContext } from '@new/features/courses/contexts/ExamProvider';

const INITIAL_PROGRESS = 0;
const PROGRESS_COMPLETE = 100;
const PROGRESS_INCREMENT = 2;
const PROGRESS_INTERVAL_MS = 30;
const COMPLETION_DELAY_MS = 200;

export const ExamLoadingModal: FC = () => {
  const { examMode, setExamMode } = useExamContext();
  const [progress, setProgress] = useState(INITIAL_PROGRESS);
  const isOpen = examMode.type === 'loading';

  if (progress >= 100 && isOpen) {
    setTimeout(() => {
      setExamMode({ type: 'result' });
    }, COMPLETION_DELAY_MS);
  }

  useEffect(() => {
    if (!isOpen) {
      setProgress(INITIAL_PROGRESS);
      return;
    }

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= PROGRESS_COMPLETE) {
          clearInterval(interval);
          return PROGRESS_COMPLETE;
        }
        return prev + PROGRESS_INCREMENT;
      });
    }, PROGRESS_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      isOpen && setExamMode({ type: 'result' });
    };
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <div className="flex flex-col items-center justify-center p-8 sm:p-12 text-center">
        <img src={ManWithBulbSvg} alt="Man with bulb" className="w-48 h-48 sm:w-56 sm:h-56 mb-6" />

        <h2 className="[font-family:var(--font-arvo)] text-[28px] sm:text-[32px] font-bold text-(--neutral-black-NB1000)! mb-3">
          Exam submitted.
        </h2>

        <p className="[font-size:var(--fs-p2)]! text-(--neutral-black-NB600)! mb-8">
          We are calculating your exam results.
        </p>

        <div className="w-full flex items-center gap-4">
          <Progress value={progress} className="flex-1 h-3" />
          <span className="[font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB1000)! min-w-15 text-right">
            {progress}%
          </span>
        </div>
      </div>
    </Modal>
  );
};
